import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FieldsInterventionTimeWidgetComponent } from './fields-intervention-time-widget.component';
import {DxChartModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionTimeWidgetComponent],
    imports: [
        CommonModule,
        DxChartModule
    ],
  exports: [FieldsInterventionTimeWidgetComponent]
})
export class FieldsInterventionTimeWidgetModule { }
